import React from "react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";
const Header = () => {
  return <header className="border-b shadow-sm py-4 bg-white sticky top-0 z-10">
      <div className="container max-w-7xl mx-auto px-4 flex justify-between items-center">
        <div className="flex items-center">
          <img 
            src="/lovable-uploads/24e0e29e-3e10-43db-8be9-1cc4bc18ab2f.png" 
            alt="TocToc Logo" 
            loading="eager"
            width="114"
            height="64"
            className="h-14"
            decoding="async"
          />
        </div>
        <nav className="hidden md:flex space-x-8 items-center">
          <a href="#beneficios" className="text-toctoc-gray-dark hover:text-toctoc-blue font-medium transition-colors">
            Benefícios
          </a>
          <a href="#planos" className="text-toctoc-gray-dark hover:text-toctoc-blue font-medium transition-colors">
            Planos
          </a>
          <a href="#para-quem" className="text-toctoc-gray-dark hover:text-toctoc-blue font-medium transition-colors">
            Para quem
          </a>
          <a href="#teste-gratis" className="text-toctoc-gray-dark hover:text-toctoc-blue font-medium transition-colors">
            Teste Grátis
          </a>
          <Button variant="default" className="bg-toctoc-orange hover:bg-orange-600 text-white">
            Assinar agora
          </Button>
        </nav>
        <Sheet>
          <SheetTrigger asChild>
            <Button variant="ghost" className="md:hidden">
              <Menu className="h-6 w-6" />
            </Button>
          </SheetTrigger>
          <SheetContent side="right">
            <div className="flex flex-col gap-4 mt-8">
              <a href="#beneficios" className="text-lg text-toctoc-gray-dark hover:text-toctoc-blue font-medium transition-colors">
                Benefícios
              </a>
              <a href="#planos" className="text-lg text-toctoc-gray-dark hover:text-toctoc-blue font-medium transition-colors">
                Planos
              </a>
              <a href="#para-quem" className="text-lg text-toctoc-gray-dark hover:text-toctoc-blue font-medium transition-colors">
                Para quem
              </a>
              <a href="#teste-gratis" className="text-lg text-toctoc-gray-dark hover:text-toctoc-blue font-medium transition-colors">
                Teste Grátis
              </a>
              <Button className="w-full mt-4 bg-toctoc-orange hover:bg-orange-600 text-white">
                Assinar agora
              </Button>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>;
};
export default Header;